import { get } from "lodash";
import React from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import FormModal from "src/components/FormModalV2/FormModal";
import DisTable from "src/components/TableV2/Table";
import useAutosave from "src/hooks/useAutosave";
import { IApplicationMemo } from "src/store/models/application.model";
import { fetchAppMemosList } from "src/store/reducers/applicationMemos";
import { openUrl } from "src/util/util.navigation";
import { formatDate } from "src/views/CampaignDetail/utils";
import * as S from "../../../../constants/StringConstants";
import { PageContainerButtons } from "../../PageContainer";
import { TabProps } from "../../pages";
import { MyEditor } from "./MyEditor";

const columns = [
  { key: "memoDescription", title: S.APP_MEMOS_COL_MEMO, style: { minWidth: "5rem" } },
  { key: "delivery", title: S.APP_MEMOS_COL_DELIVERY, style: { minWidth: "5rem" } },
  { key: "status", title: S.APP_MEMOS_COL_STATUS, style: { minWidth: "5rem" } },
  {
    key: "memoOrdered",
    title: S.APP_MEMOS_COL_ORDERED,
    style: { minWidth: "5rem" },
    render: (item: IApplicationMemo) => formatDate(item.memoOrdered),
  },
  {
    key: "memoDelivered",
    title: S.APP_MEMOS_COL_DELIVERED,
    style: { minWidth: "5rem" },
    render: (item: IApplicationMemo) => formatDate(item.memoDelivered),
  },
  { key: "memoRecipient", title: S.APP_MEMOS_COL_RECIPIENT, style: { minWidth: "5rem" } },
  { key: "requestedBy", title: S.APP_MEMOS_COL_REQUESTED_BY, style: { minWidth: "5rem" } },
];

export const AppMemos = (props: TabProps) => {
  const { id: appId } = useParams<{ id: string }>();
  const [selectedMemo, setSelectedMemo] = React.useState<IApplicationMemo | null>(null);
  const dispatch = useDispatch();
  const AutoSave = useAutosave(props, () => {});

  return (
    <div>
      <DisTable<IApplicationMemo>
        columns={columns}
        initialState={{}}
        onRowClick={(data: IApplicationMemo) => setSelectedMemo(data)}
        onUpdate={async ({ page, rows, sort, query }) => {
          const result: any = await dispatch(fetchAppMemosList({ appId, page, rows, sort, query }));

          return {
            total: get(result, "value.data.totalRows", 0) as number,
            data: get(result, "value.data.items", []) as IApplicationMemo[],
          };
        }}></DisTable>
      <PageContainerButtons>
        <button className="button-v2 button-v2__secondary" onClick={() => openUrl(`${location.pathname}/new`)}>
          {S.APP_REQS_ADD_MEMO_TITLE}
        </button>
      </PageContainerButtons>
      <FormModal
        open={selectedMemo !== null}
        title={selectedMemo?.memoDescription}
        saveLabel={null}
        onCancel={() => setSelectedMemo(null)}
        values={{}}
        onSubmit={() => {}}>
        <MyEditor content={selectedMemo?.memoBody} readOnly={true} />
      </FormModal>
      <AutoSave />
    </div>
  );
};
